import { KeycloakOnLoad } from "keycloak-js";

export const environment = {
  appname: "KonflexHub",
  production: false,
  version: '2.0.34',
  url: 'https://konflexhub-test.lacuna-space.com/',
  url_gatewayApi : 'https://konflexhub-test.lacuna-space.com/api/v0',
  appsignalKey: '8b5c0187-ab76-4c04-98eb-259bf6ffa0ff',
  keyCloakConfig: {
    url: 'https://keycloak-test.lacuna-space.com/auth',
    realm: 'lacuna-user-platform',
    clientId: 'gateway'
  },
  keyCloakInitOptions: {
    // redirectUri: 'https://api2.lacuna-space.com/webui-dashboard',
    checkLoginIframe: false,
    onLoad: <KeycloakOnLoad>'login-required',
    silentCheckSsoRedirectUri: 'https://keycloak-test.lacuna-space.com/auth'
  }
}
